export default "/images/vendor/flag-icons/flags/4x3/mt.svg?3f7bf9b723ad1e5724d76f53a27fea27";